import React from "react";
import { Box, Tooltip } from "@mui/material";

export const ExplorerDetailTableHeaderLabel: React.FC<{
  label: string;
  tooltip: string;
  align?: "left" | "right";
}> = ({ label, tooltip, align = "left" }) => (
  <Tooltip title={tooltip} arrow placement="top">
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        ...(align === "right" ? { ml: "auto" } : {}),
      }}
    >
      {label}
    </Box>
  </Tooltip>
);
